export default __webpack_public_path__ + "static/media/windy.30657e80.svg";